// Permission gate for Inventory master screens.
// Mirrors MoceroUI's checkPermission (Inventory/Service/AccessControl) and the
// accounts module's accounts/services/accessControl.ts so every Inventory master
// can block Add/Edit/Delete/Read when the role lacks the right.
//
// `Rights` comes from EntityOperationsDeptRoleMap/CheckMenuRights (per-operation
// IsActive flag). `action` is one of "Add" | "Edit" | "Delete" | "Read".

export interface Rights {
  Create: boolean
  Update: boolean
  Read: boolean
  Delete: boolean
}

export interface PermissionResult {
  hasPermission: boolean
  toast: {
    severity: string
    summary: string
    detail: string
    life: number
  } | null
}

export function checkPermission(rights: Rights, action: 'Add' | 'Edit' | 'Delete' | 'Read'): PermissionResult {
  const allowed =
    (action === 'Add' && rights?.Create === true) ||
    (action === 'Edit' && rights?.Update === true) ||
    (action === 'Read' && rights?.Read === true) ||
    (action === 'Delete' && rights?.Delete === true)

  if (allowed) return { hasPermission: true, toast: null }

  // MoceroUI parity: summary "Access Denied" + detail message, life 3000.
  return {
    hasPermission: false,
    toast: {
      severity: 'warn',
      summary: 'Access Denied',
      detail: 'You do not have permission to access this feature. Please contact your administrator for assistance.',
      life: 3000
    }
  }
}
